<template>
    <div class="service-type">
            <base-dialog v-model="activateInterconsultationsModal" :okBtnText="$t('chats.go-my-services')" :okFn="() => { $helpers.goToWebApp('HomeProfesional#/services', $apiToken)}" :cancelFn="() => { activateInterconsultationsModal = false }"><p v-html="$t('chats.go-activate-interconsultations')"></p></base-dialog>
            <div class="service-type-block" v-for="service in activeServices" :key="service.name" @click="service.action">
                <base-icon :src="service.icon" alt :height="iconSize" :width="iconSize" :color="BLUE_COLOUR" class="d-block mb-3"></base-icon>
                <div class="service-name mt-1" v-html="service.name"></div>
                <b-badge :class="{ 'blink': blinkSoonLabelActive }" v-if="service.name === $t('professionalServices.facilityRent')" variant="primary">{{ $t('soon-label') }}</b-badge>
            </div>
        </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { BLUE_COLOUR } from '@/constants/colours'
import BaseDialog from '@/components/base/BaseDialog.vue'

export default {
    components: {
		BBadge,
        BaseDialog
    },
    props: {
        hasInterconsultations: {
            type: Boolean,
            default: false
        },
        loggedProfAllowInterconsultations: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            profServices: [
                {
                    name: this.$t('professionalServices.sendMessage'),
                    icon: '/static-appopensalud/img/icons/morillas-svg-icons/primary/chat.svg',
                    active: true,
                    action: this.sendMessage
                },
                {
                    name: this.$t('professionalServices.interconsultation'),
                    icon: '/static-appopensalud/img/icons/morillas-svg-icons/primary/interconsultations.svg',
                    active: this.hasInterconsultations,
                    action: this.createInterconsultation
                },
                {
                    name: this.$t('professionalServices.facilityRent'),
                    icon: '/static-appopensalud/img/icons/morillas-svg-icons/primary/facility-rent.svg',
                    active: this.hasInterconsultations,
                    action: this.checkFacilities
                }
            ],
            blinkSoonLabelActive: false,
            activateInterconsultationsModal: false,
            BLUE_COLOUR
        }
    },
    methods: {
        sendMessage () {
            this.$emit('showInterconsultationModal', false)
        },
        createInterconsultation () {
            if (this.loggedProfAllowInterconsultations) {
                this.$emit('showInterconsultationModal', true)
            } else {
                this.activateInterconsultationsModal = true
            }
        },
        checkFacilities () {
            this.highlightSoonLabel()
        },
        highlightSoonLabel () {
            this.blinkSoonLabelActive = true
            setTimeout(() => {
                this.blinkSoonLabelActive = false
            }, 4000)
        }
    },
    computed: {
        activeServices () {
            return this.profServices.filter(s => s.active)
        },
        iconSize () {
            return !this.$uiHelpers.isXlDevice ? '30' : '40'
        }
    }
}
</script>

<style lang="scss" scoped>
.service-type-block{
    text-align: center;
    -webkit-box-shadow: -10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);
    box-shadow: -10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);
    padding: 1.5rem 0.5rem;
    border-radius: 23px;
    border: 1px solid #eee;
    background-color: #eee;
    flex-basis: 50%;
    font-size: 11px;
    cursor: pointer;
    color: $blue;
    max-width: 220px;
}
.icon-service{
    width: 36px;
    height: 36px;
}
.blue{
    color: $blue;
}
.bold{
    font-weight: bold
}
.service-name{
    color: $blue;
    font-weight: bold;
    text-transform: uppercase;
}
.service-type{
    display: flex;
    gap: 1.8rem;
    flex-direction: row;
    @include screen-xl-grid-max  {
      justify-content: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/professional/interconsultations/SearchBlocksProfessional.vue